import React from "react";
import { useI18n } from "src/utils/lni18n";
import { AlertDialog, AlertOptions } from "./AlertDialog";
import { useInnerDialog } from "./useInnerDialog";
import { errorEventEmitter, ErrorMessage, ErrorService, LnErrorEvent } from "../Error/ErrorService";
import DOMPurify from 'dompurify';


export const UseDialogErrorAlert = () => {
    const [dialogElement, onInnerDialog] = useInnerDialog();

    const { languageService: t } = useI18n();

    React.useEffect(() => {


        const listener = errorEventEmitter.on("errorChanged", (event: LnErrorEvent) => {
            if (!event.inDialogContext) return;
            showErrors(event.data);
        });

        return () => {

            if (listener !== null) {
                listener.dispose();
            }
        }
    }, [])

    const showErrors = (messages: ErrorMessage[]) => {
    
            if (messages && messages.length > 0) {
                onInnerDialog((onsubmit) => {
    
                    const message = messages[0].htmlMessage
                     ? <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(messages[0].htmlMessage!) }} /> 
                     : messages[0].message;
    
                    const dprops: AlertOptions = {
                        title: t.getText("error"),
                        message: message,
                        languageService: t,
                        onSubmit: onsubmit,
                        className: ""
                    }
                    return <AlertDialog {...dprops} />;
    
                } ).finally(() => ErrorService.clearError(messages[0]) );
            }
        };


    return dialogElement;

}